import { HttpClient } from '@angular/common/http';
import { ApiResponse } from '@core/models/api-response.model';
import { Injectable } from '@angular/core';
import { map, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Dropdown } from '@core/models/dropdown.model';

@Injectable()
export class TimezoneHttpService {

  constructor(private http: HttpClient) { }

  getTimezone(): Observable<Dropdown[]> {
    return this.http.get<ApiResponse>(`/timezone`).pipe(
      map(res => res.data.rows),
      tap(res => sessionStorage.setItem('timezones', JSON.stringify(res)
      ))
    );
  }

  setTimezone(): Observable<Dropdown[]> {
    return this.http.get<ApiResponse>(`/timezone`).pipe(
      map(res => res.data.rows),
      tap(res => localStorage.setItem('timezones', JSON.stringify(res)
      )),
    );
  }
}
